import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import InputField from '../../components/InputField';
import { KONUSU_PARA_OLAN_MAHKEMELER, KONUSU_PARA_OLMAYAN_MAHKEMELER, DIGER_MAHKEMELER, VEKALET_MINIMUM_COST, VEKALET_MINIMUM_LIMIT, VEKALET_VERGI_ARALIGI } from '../../constants/constants';
import Dropdown from '../../components/Dropdown';
import Header from '../../components/Header';

const faqs = [
    {
        question: "<h5>Vekalet Ücreti Nasıl Hesaplanır?</h5>",
        answer: ["Türkiye Barolar Birliği (TBB) tarafından her yıl güncellenen \"Avukatlık Asgari Ücret Tarifesi\" vekalet ücretinin hesaplanmasında temel referans olarak kullanılır. Bu tarife, dava türlerine göre asgari ücretler belirler. Asgari ücretin altında vekalet ücreti talep edilemez. Bu sayfada asgari ücretler gösterilmektedir. Bununla birlikte:"],
    },
    {
        question: "<h5>Vekalet Ücretini Etkileyen Faktörler:</h5>",
        answer: [
            "<strong>Dava Türü:</strong> Farklı dava türleri için farklı asgari ücretler belirlenmiştir. Örneğin, bir boşanma davası için talep edilen ücret, bir icra takibi için talep edilen ücretten farklı olacaktır.",
            "<strong>Davanın Zorluk Derecesi:</strong> Karmaşık ve kapsamlı delil gerektiren davalar, daha basit davalara göre daha yüksek vekalet ücreti gerektirebilir.",
            "<strong>Avukatın Tecrübesi:</strong> Uzun yıllara dayanan tecrübeye sahip avukatlar, daha yüksek vekalet ücreti talep edebilir.",
            "<strong>Harcanılan Zaman ve Çaba:</strong> Davanın takibi için gereken hazırlık çalışmaları, duruşmalara katılım, delil toplama gibi unsurlar avukatın harcadığı zamanı ve çabayı etkiler. Bu durum da vekalet ücretini etkileyebilir.",
            "<strong>Başarı Ödülü:</strong> Bazı durumlarda avukat ile müvekkil arasında başarıya bağlı olarak ek bir ücret ödenmesi konusunda anlaşma sağlanabilir.",
        ],
    },
    {
        question: "<h5>Vekalet Ücreti Ödeme Şekli:</h5>",
        answer: ["Vekalet ücreti, avukat ile müvekkil arasında yapılan anlaşmaya göre peşin veya taksitler halinde ödenebilir. Bazı durumlarda dava sonunda başarı elde edilmesi koşuluyla ücret ödenmesi şeklinde de anlaşma sağlanabilir."],
    },
];

const isTurleri = [
    { text: "İcra Takibi", value: 1 },
    { text: "Konusu Para Olan Dava ve İşler", value: 2 },
    { text: "Konusu Para Olmayan Dava ve İşler", value: 3 },
    { text: "Diğer Hukuki Dava ve İşler", value: 4 },
];

function calculateVekalet(price) {
    let totalTax = 0;

    for (let i = 0; i < VEKALET_VERGI_ARALIGI.length; i++) {
        const bracket = VEKALET_VERGI_ARALIGI[i];

        if (price > bracket.min) {
            const taxableIncome = Math.min(price, bracket.max) - bracket.min;
            totalTax += taxableIncome * bracket.rate;
        } else {
            break;
        }
    }

    return totalTax;
}

const VekaletUcretiHesaplama = () => {
	const [hideAll, setHideAll] = useState(false);
	const [results, setResults] = useState([]);
	const [calculated, setCalculated] = useState(false);

    const [tutar, setTutar] = useState(null);
    const [secilenIs, setSecilenIs] = useState(null);
    const [secilenKonusuParaOlan, setSecilenKonusuParaOlan] = useState(null);
    const [secilenKonusuParaOlmayan, setSecilenKonusuParaOlmayan] = useState(null);
    const [digerIsler, setDigerIsler] = useState(null);

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}
            setSecilenKonusuParaOlan(Number(decodeURIComponent(atob(query.get('secilenKonusuParaOlan')))));
            setSecilenKonusuParaOlmayan(Number(decodeURIComponent(atob(query.get('secilenKonusuParaOlmayan')))));
            setDigerIsler(Number(decodeURIComponent(atob(query.get('digerIsler')))));
            setTutar(Number(decodeURIComponent(atob(query.get('tutar')))));
            setSecilenIs(Number(decodeURIComponent(atob(query.get('secilenIs')))));
			setCalculated(true);
		}

		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
        if(secilenIs) {
            let newResults = [];

            // İcra Takibi
            if (secilenIs === 1 && tutar) {
                if (tutar <= VEKALET_MINIMUM_LIMIT) {
                    newResults = [
                        { text: "Vekalet Ücreti", value: Math.min(tutar, VEKALET_MINIMUM_COST) },
                    ];
                } else {
                    newResults = [
                        { text: "Vekalet Ücreti", value: calculateVekalet(tutar) },
                    ];
                }
            }
            // Konusu para olan dava ve işler
            else if (secilenIs === 2 && secilenKonusuParaOlan && tutar) {
                newResults = [
                    { text: "Vekalet Ücreti", value: Math.max(calculateVekalet(tutar), Math.min(secilenKonusuParaOlan, tutar)) },
                ];
            }
            // Konusu para olmayan dava ve işler
            else if (secilenIs === 3 && secilenKonusuParaOlmayan) {
                newResults = [
                    { text: "Vekalet Ücreti", value: secilenKonusuParaOlmayan },
                ];
            }
            // Diğer hukuki ve dava işleri
            else if (secilenIs === 4 && digerIsler) {
                newResults = [
                    { text: "Vekalet Ücreti", value: digerIsler },
                ];
            }
            else {
                alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
                return;
            }

            setHideAll(true);

            const params = new URLSearchParams({
                results: btoa(encodeURIComponent(JSON.stringify(newResults))),
                tutar: btoa(encodeURIComponent(tutar?.toString())),
                secilenIs: btoa(encodeURIComponent(secilenIs?.toString())),
                digerIsler: btoa(encodeURIComponent(digerIsler?.toString())),
                secilenKonusuParaOlan: btoa(encodeURIComponent(secilenKonusuParaOlan?.toString())),
                secilenKonusuParaOlmayan: btoa(encodeURIComponent(secilenKonusuParaOlmayan?.toString())),
            });

            navigate(`${window.location.pathname}?${params.toString()}`);
            navigate(0);
        } else {
			alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
		}
	};

    return (
        <>
            <Helmet>
                <title>Vekalet Ücreti Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Vekalet ücreti hesaplama, bir avukata veya vekile verilen temsil yetkisi karşılığında ödenecek ücreti belirlemek için yapılır. Her yıl avukatlık asgari ücret tarifesi güncellenerek resmi gazetede yayınlanmaktadır. Vekalet ücreti, asgari tarifenin altında olmamak ve dava değerinin %25’ini geçmemek kaydıyla taraflar arasında serbestçe belirlenir." />
            </Helmet>
            
            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>Vekalet Ücreti Hesaplama</li>
                    </ol>
                    <h1 className="fw-semibold">Vekalet Ücreti Hesapla</h1>
                    <p>Vekalet ücreti hesaplama, bir avukata veya vekile verilen temsil yetkisi karşılığında ödenecek ücreti belirlemek için yapılır. Her yıl avukatlık asgari ücret tarifesi güncellenerek resmi gazetede yayınlanmaktadır. Vekalet ücreti, asgari tarifenin altında olmamak ve dava değerinin %25’ini geçmemek kaydıyla taraflar arasında serbestçe belirlenir.</p>
                    
                    <Dropdown options={isTurleri} selectedOption={secilenIs} setSelectedOption={setSecilenIs} label="İş Türünü Seçiniz" />

                    {(secilenIs === 1 || secilenIs === 2) && <InputField value={tutar} setValue={setTutar} trailText="TL" label="Tutar" type="number" />}
                    {secilenIs === 2 && <Dropdown label="Dava ya da İş Seçiniz" options={KONUSU_PARA_OLAN_MAHKEMELER} setSelectedOption={setSecilenKonusuParaOlan} selectedOption={secilenKonusuParaOlan} />}
                    {secilenIs === 3 && <Dropdown label="Mahkeme Türünü Seçiniz" options={KONUSU_PARA_OLMAYAN_MAHKEMELER} setSelectedOption={setSecilenKonusuParaOlmayan} selectedOption={secilenKonusuParaOlmayan} />}
                    {secilenIs === 4 && <Dropdown label="Dava ya da İş Seçiniz" options={DIGER_MAHKEMELER} setSelectedOption={setDigerIsler} selectedOption={digerIsler} />}
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} />
            </section>

            <Footer faqs={faqs} faqTitle="Vekalet Ücreti Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(VekaletUcretiHesaplama);
